import React from 'react';
import IconCollection from '../../IconCollection/IconCollection';

const ExpendPanel = ({ matchStatus, setExpendPanel }) => {
  return (
    <div className="max-w-[136px] h-8 w-full absolute top-[-2px] right-[9px] lg:right-[73px]">
      {/* Desktop live icon */}
      <span className="lg:block hidden">
        <IconCollection name="live-icon-bg" />
      </span>

      {/* Mobile live icon */}
      <span className="lg:hidden block">
        <IconCollection name="live-icon-bg-mobile" />
      </span>

      {/* Match status messages */}
      {matchStatus === "Waiting to start" && (
        <p className="text-[#DB5F66] font-bebas lg:text-base text-[10px] absolute top-[6px] text-center left-4 right-0">
          Waiting to start
        </p>
      )}
      {matchStatus === "pause" && (
        <p className="text-[#DB5F66] font-bebas absolute top-[6px] lg:text-base text-[10px] text-center left-4 right-0">
          Pause
        </p>
      )}
      {matchStatus === "liveEnd" && (
        <p className="text-[#DB5F66] font-bebas absolute top-[6px] lg:text-base text-[10px] text-center left-4 right-0">
          Live End
        </p>
      )}

      {/* Live status */}
      {matchStatus === "live" && (
        <>
          <div className="max-w-[50px] w-full top-[4px] lg:h-[22px] h-4 lg:text-base text-[10px] left-[37px] rounded lg:rounded px-2 flex justify-between items-center border-[1px] border-[#DB5F66] absolute">
            <p className="font-bebas text-xs lg:text-[10px] text-[#DB5F66]">live</p>
            <div className="w-2 h-2 bg-[#D54043] rounded-full"></div>
          </div>

          <div className="cursor-pointer font-bebas text-[10px] text-[#CCCCCC] absolute top-[4px] right-[20px]">
            End
          </div>
        </>
      )}

      {/* Expend button */}
      <button
        onClick={() => setExpendPanel(true)}
        className="absolute top-[-2px] right-[7px] lg:right-[-8px]"
      >
        <IconCollection
          customClass="max-w-[10px] lg:max-w-4 w-full lg:h-4 h-[10px]"
          name="extend-icon"
        />
      </button>
    </div>
  );
};

export default ExpendPanel;
